import { COLUMN_ACCESSORS } from "../../../../constants/table";
import { actionTypes } from "../../../actions/ui/routeDetail/stopListOrder";

const initialState = {
  accessor: COLUMN_ACCESSORS.SEQUENCE_NUMBER,
  isAscending: true,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_ORDER:
      if (state.accessor === payload) {
        return {
          ...state,
          isAscending: !state.isAscending,
        };
      }

      return {
        accessor: payload,
        isAscending: true,
      };
    case actionTypes.SET_DEFAULT_ORDER:
      return initialState;
    default:
      return state;
  }
};
